<script lang="ts">
  export let headline: string;
</script>

<div class="video-caption">
  <h5>{headline}</h5>
</div>

<style>
  .video-caption {
    margin: -10px 0;
    color: var(--color-text-light);
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-light);
  }
</style>
